import styles from "./styles.scss";
import IconSend from "../../assets/icons/icon-send.svg";
import {useEffect, useRef} from "preact/hooks";
import Icon from "../Icon/Icon";
import {withAlert} from "../../contexts/AlertContext";
import ChatAttachmentModal from "../../containers/ChatAttachmentModal/ChatAttachmentModal";

const ChatInput = ({ alert, onSubmit, onFocus, silenced, restricted, onHeightChanged, onContentChanged, showHashtag, showAttachment }) => {
  const input = useRef(null);

  useEffect(() => {
    if (input && input.current)
      onHeightChanged(input.current.height);
  }, []);

  const clearInput = () => {
    input.current.value = '';
    onContentChanged('');
  };

  const onSendMessage = (content = '') => {
    if (content.length === 0)
      return;

    onSubmit(content);
    clearInput();
  };

  const showAttachmentModal = () => {
    const component = <ChatAttachmentModal onClose={() => alert.hideAlert()} />
    alert.showAlertComponent(component);
  };

  const onKeyDown = evt => {
    if (evt.key === 'Enter' && !evt.shiftKey) {
      evt.preventDefault();
      onSendMessage(evt.currentTarget.value);
    }
    setTimeout(() => {
      // Somehow this doesn't work if we don't wrap it in a timeout, it gets the value before the change
      if (input && input.current) {
        input.current.style.height = 'auto';
        const height = Math.min(input.current.scrollHeight, 250);
        input.current.style.height = height + 'px';
        input.current.style.overflowY = height >= 250 ? 'visible' : 'hidden';
        onHeightChanged(height);
        onContentChanged(input.current.value);
      }
    }, 10);
  };

  const addHashtag = () => {
    onHeightChanged(Math.min(input.current.scrollHeight, 250));
    input.current.value += "#";
    onContentChanged(input.current.value);
    input.current.focus();
  };

  const isDisabled = silenced || restricted;
  let message = 'Digite uma mensagem';

  if (silenced) {
    message = 'Você está silenciado';
  }
  if (restricted) {
    message = 'Um moderador fechou a sala';
  }

  return (
    <form
      className={styles.container}
      onSubmit={evt => {
        evt.preventDefault();
        onSendMessage(input.current.value);
        return false;
      }}
    >
      <div className={[styles.inputContainer, isDisabled && styles.inputContainerDisabled].join(" ")}>
        <div className={styles.toolsContainer}>
          {showHashtag && <Icon onClick={addHashtag} color={'#BDBDBD'} className={styles.inputIcon} name="pound_box_outline" />}
          {showAttachment && <Icon onClick={showAttachmentModal} color={'#BDBDBD'} className={styles.inputIcon} name="paperclip" />}
        </div>
        <textarea
          ref={input}
          placeholder={message}
          className={styles.input}
          autoComplete="off"
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          disabled={isDisabled}
          maxLength={280}
        />
      </div>
      <button type="submit" className={styles.sendMessageButton} disabled={isDisabled}>
        <IconSend className={styles.sendMessageIcon} />
      </button>
    </form>
  );
};

export default withAlert(ChatInput);



// WEBPACK FOOTER //
// ./components/chat-input/index.js